import {
    TextField as SearchTextInput, makeStyles,
    Button, Switch, Chip
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: theme.spacing(0.5),
        margin: 0,
        width: '100%'
    },
    chip: {
        margin: theme.spacing(0.5),
    },
    table: {
        minWidth: 650,
    }
}));


export function UserIdentificationSearch({filterList, setFilterList}: any): React.ReactElement {

    return (
        <div className='search-panel' style={{ marginBottom: '2rem' }}>
            <p style={{ fontFamily: 'IranSans-Bold'}}>
                برای جستجو بین فایل‌ها، فیلدهای زیر را پُر کنید:
            </p>        
            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', flexDirection: 'column', gap: '0.5rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0.5rem', width: '100%' }}>
                    <SearchTextInput
                        fullWidth
                        id="outlined-select-currency-native"
                        onChange={(e) => setFilterList({ ...filterList, campaign: { contains: e.target.value } })}
                        variant="outlined"
                        value={filterList.campaign.contains}
                        placeholder="کمپین"
                    >
                    </SearchTextInput>                                      
                </div>
            </div>
        </div>
    )
}